/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{font-size:.8125em;font-weight:600;white-space:nowrap}.status-expiring[_nghost-%COMP%], .status-filled[_nghost-%COMP%], .status-newed[_nghost-%COMP%]{padding:.3125rem .625rem;border-radius:.625rem}.status-newed[_nghost-%COMP%]{background-color:rgba(67,206,255,.15);color:#43ceff}.status-expiring[_nghost-%COMP%]{background-color:rgba(135,130,255,.15);color:#8782ff}.status-filled[_nghost-%COMP%]{background-color:rgba(255,92,96,.15);color:#ff5c60}[_nghost-%COMP%]   .days[_ngcontent-%COMP%]{font-weight:600}"];
export { styles as styles };
